<template>
  <div class="client-rescheduler">
    <div class="row">
      <div class="col-lg-8 col-12">
        <cronofy-availability-viewer
          :client="client"
          :selected-slot="selectedSlot"
          @set-selected-slot="setSelectedSlot"
        />
      </div>
      <div class="dashboard-card col-lg-4 col-12">
        <client-event-card
          :selected-slot="selectedSlot"
          :saving="saving"
          @confirm-clicked="rescheduleSession"
        />
      </div>
    </div>
  </div>
</template>

<script>
import SessionClient from '@/api/SessionClient';
import ClientEventCard from '@/components/scheduling/ClientEventCard.vue';
import CronofyAvailabilityViewer from '@/components/scheduling/CronofyAvailabilityViewer.vue';

export default {
    name: 'ClientRescheduler',
    components: {
      ClientEventCard,
      CronofyAvailabilityViewer
    },
    props: {
        client: {
            type: Object,
            required: true
        },
    },
    data() {
      return {
        sessionsClient: new SessionClient(this.$http),
        saving: false,
        selectedSlot: {}
      }
    },
    methods: {
      setSelectedSlot(slotData) {
        if (slotData.events) {
          slotData.events.forEach(event => {
            event.isOverridable = this.isEventOverridable(event, slotData.start);
          });
        }
        this.selectedSlot = slotData;
      },
      isEventOverridable(event, slotStart) {
        return !!(event.id === this.client.appointment.cronofyEventId && slotStart !== event.start);
      },
      async rescheduleSession() {
        try {
          this.saving = true;
          await this.sessionsClient.rescheduleSession(
            this.client.appointment.id, 
            this.selectedSlot.start, 
            this.selectedSlot.end)
          
          this.$store.commit('setGlobalAlert', {
            msg: 'Session Rescheduled!'
          });
        } catch (ex) {
          this.$store.commit('setGlobalAlert', {
            msg: 'Failed to rechedule session. Please try again!', error: true,
          });
        } finally {
          this.saving = false;
          this.$emit('clear-scheduling', {});
        };
      }
    }
}
</script>

<style lang="scss">
.client-rescheduler {
  .scheduler {
    .scheduler__navigation {
      position: absolute;
      top: 0;
      right: 0;
    }

    .scheduler__month-labels {
      padding-top: 20px;
    }

    .scheduler__example.scheduler__example--unavailable {
      background-color: #fff;
    }

    .scheduler__time-text {
      color: #fff;
    }

    .scheduler__month-labels {
      padding-top: 0px;

      .scheduler__month-label {
        font-size: 30px;
      }
    }
  }

  .dashboard-card {
    padding: 0;
    margin-top: 5.8rem;
  }
}

</style>
